<div *ngIf="czyPrzedmiotZUszkodzeniem; else bezUszkodzen" class="accordion" (click)="kliknietoNaWiersz()">
    <li class="d-flex flex-column flex-fill">
        <div class="d-flex flex-row g-12 align-items-center flex-fill">
            <div class="d-flex flex-row justify-content-center">
                <img class="arrow {{isOpen ? 'is-active' : ''}}" src="assets/images/arrow.svg">
            </div>
            <app-podsumowanie-z-uszkodzeniem
                    class="flex-fill"
                    [lokalizacja]="zbiorUszkodzen.lokalizacja"
                    [zbiorUszkodzenPrzedmiotuId]="zbiorUszkodzenPrzedmiotuId"
                    [zbiorUszkodzen]="zbiorUszkodzen"
                    (usunZbiorUszkodzenClick)="usunZbiorUszkodzen($event)">
            </app-podsumowanie-z-uszkodzeniem>
        </div>
        <div class="content"
             [@open-close]="isOpen"
             (@open-close.done)="afterAnimationEnd()">
            <ng-container *ngFor="let uszkodzenie of zbiorUszkodzen.uszkodzenia">
                <app-uszkodzenie
                        [zbiorUszkodzenPrzedmiotuId]="zbiorUszkodzenPrzedmiotuId"
                        [uszkodzenie]="uszkodzenie"
                        [zbiorUszkodzenId]="zbiorUszkodzen.id"
                        (usunUszkodzenieClick)="usunUszkodzenie($event)">
                </app-uszkodzenie>
            </ng-container>
        </div>
    </li>
</div>

<ng-template #bezUszkodzen>
    <app-podsumowanie-bez-uszkodzen
            [lokalizacja]="zbiorUszkodzen.lokalizacja"
            [zbiorUszkodzenPrzedmiotuId]="zbiorUszkodzenPrzedmiotuId"
            [zbiorUszkodzenId]="zbiorUszkodzen.id"
            [opisLokalizacji]="zbiorUszkodzen.opisLokalizacji"
            (usunZbiorUszkodzenClick)="usunZbiorUszkodzen($event)">
    </app-podsumowanie-bez-uszkodzen>
</ng-template>
